/**
 * Client API simplifié pour les services spécifiques
 * Utilise le service API principal avec des méthodes spécifiques
 * pour des endpoints particuliers
 */
import api from '../services/api';

/**
 * Effectue une requête GET
 * @param {string} url - URL relative de l'endpoint
 * @param {Object} params - Paramètres de requête
 * @returns {Promise} - Promesse résolue avec la réponse
 */
export const get = async (url, params = {}) => {
  try {
    const response = await api.get(url, { params });
    return response.data;
  } catch (error) {
    console.error(`API GET error for ${url}:`, error);
    throw error;
  }
};

/**
 * Effectue une requête POST
 * @param {string} url - URL relative de l'endpoint
 * @param {Object} data - Données à envoyer
 * @returns {Promise} - Promesse résolue avec la réponse
 */
export const post = async (url, data = {}) => {
  try {
    const response = await api.post(url, data);
    return response.data;
  } catch (error) {
    console.error(`API POST error for ${url}:`, error);
    throw error;
  }
};

/**
 * Effectue une requête PUT
 * @param {string} url - URL relative de l'endpoint
 * @param {Object} data - Données à envoyer
 * @returns {Promise} - Promesse résolue avec la réponse
 */
export const put = async (url, data = {}) => {
  try {
    const response = await api.put(url, data);
    return response.data;
  } catch (error) {
    console.error(`API PUT error for ${url}:`, error);
    throw error;
  }
};

/**
 * Effectue une requête DELETE
 * @param {string} url - URL relative de l'endpoint
 * @returns {Promise} - Promesse résolue avec la réponse
 */
export const del = async (url) => {
  try {
    const response = await api.delete(url);
    return response.data;
  } catch (error) {
    console.error(`API DELETE error for ${url}:`, error);
    throw error;
  }
};

/**
 * Récupère l'instance API principale
 * @returns {AxiosInstance} - L'instance Axios configurée
 */
export const getApiInstance = () => api;

export default {
  get,
  post,
  put,
  delete: del,
  getApiInstance
};
